import { use, useCallback } from "react";
import { appendBaseUrl } from "../fork/getPathFromState-mods";
import { router } from "../router/imperative-api";
import { stripGroupSegmentsFromPath } from "../router/matchers";
import { useNavigatorContext } from "../views/Navigator";
import { TabTriggerMapContext } from "./TabContext";
function shouldHandleMouseEvent(event) {
  if (!event) return true;
  if ("button" in event) {
    return !event.metaKey && !event.altKey && !event.ctrlKey && !event.shiftKey && (event.button == null || event.button === 0) && [
      void 0,
      null,
      "",
      "self"
    ].includes(event.currentTarget.target);
  }
  return true;
}
function useTabTrigger(options) {
  var { state, navigation } = useNavigatorContext();
  var { name, resetOnFocus, onPress, onLongPress } = options;
  var triggerMap = use(TabTriggerMapContext);
  var getTrigger = useCallback(function(name2) {
    var config = triggerMap[name2];
    if (!config) return;
    return {
      isFocused: state.index === config.index,
      route: state.routes[config.index],
      resolvedHref: stripGroupSegmentsFromPath(appendBaseUrl(config.href)),
      ...config
    };
  }, [
    triggerMap,
    state
  ]);
  var trigger = name !== void 0 ? getTrigger(name) : void 0;
  var switchTab = useCallback(function(name2, options2) {
    var config = triggerMap[name2];
    if (config) {
      if (config.type === "external") {
        return router.navigate(config.href);
      }
      return navigation === null || navigation === void 0 ? void 0 : navigation.dispatch({
        ...config.action,
        type: "JUMP_TO",
        payload: {
          ...config.action.payload,
          ...options2
        }
      });
    }
    return navigation === null || navigation === void 0 ? void 0 : navigation.dispatch({
      type: "JUMP_TO",
      payload: {
        name: name2
      }
    });
  }, [
    navigation,
    triggerMap
  ]);
  var handleOnPress = useCallback(function(event) {
    onPress === null || onPress === void 0 ? void 0 : onPress(event);
    if (!trigger || (event === null || event === void 0 ? void 0 : event.isDefaultPrevented())) return;
    navigation === null || navigation === void 0 ? void 0 : navigation.emit({
      type: "tabPress",
      target: trigger.type === "internal" ? trigger.route.key : trigger.href,
      canPreventDefault: true
    });
    if (!shouldHandleMouseEvent(event) || trigger.isFocused) return;
    switchTab(name, {
      resetOnFocus
    });
  }, [
    onPress,
    name,
    resetOnFocus,
    trigger,
    navigation,
    switchTab
  ]);
  var handleOnLongPress = useCallback(function(event) {
    onLongPress === null || onLongPress === void 0 ? void 0 : onLongPress(event);
    if (!trigger || (event === null || event === void 0 ? void 0 : event.isDefaultPrevented())) return;
    navigation === null || navigation === void 0 ? void 0 : navigation.emit({
      type: "tabLongPress",
      target: trigger.type === "internal" ? trigger.route.key : trigger.href
    });
    if (!shouldHandleMouseEvent(event)) return;
    switchTab(name, {
      resetOnFocus
    });
  }, [
    onLongPress,
    name,
    resetOnFocus,
    trigger,
    navigation,
    switchTab
  ]);
  return {
    switchTab,
    getTrigger,
    trigger,
    triggerProps: {
      isFocused: Boolean(trigger === null || trigger === void 0 ? void 0 : trigger.isFocused),
      onPress: handleOnPress,
      onLongPress: handleOnLongPress
    }
  };
}
export {
  shouldHandleMouseEvent,
  useTabTrigger
};
//# sourceMappingURL=useTabTrigger.js.map
